<template>
  <li class="ContentProseLi"><slot /></li>
</template>

<style lang="scss">
.ContentProseLi {
  list-style-position: inside;
  margin: var(--spacing-2x);
}
</style>
